<template>
  <v-card flat>
    <v-card-title>
      <v-spacer></v-spacer>
      <span class="float-right">
        <v-btn
          depressed
          @click="
            !edittxnDialog ? (edittxnDialog = true) : (edittxnDialog = false)
          "
          dense
          v-if="txn_status === 'Paid' || txn_status === 'Post' ? false : true"
          text
          class="me-2"
          color="primary"
          ><v-icon class="me-2">mdi-square-edit-outline </v-icon>Edit
        </v-btn>
      </span>
    </v-card-title>
    <v-simple-table>
      <tr>
        <td>Collected Amount</td>
        <td>
          <span class="font-weight-bold">{{
            transactionInfo.total_coll_amt
              ? transactionInfo.total_coll_amt
              : null
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="">Service Charge</td>
        <td class="font-weight-bold">
          {{
            transactionInfo.service_charge
              ? transactionInfo.service_charge
              : null
          }}
        </td>
      </tr>

      <tr>
        <td>Transfer Amount</td>
        <td class="font-weight-bold">
          {{
            transactionInfo.transfer_amt ? transactionInfo.transfer_amt : null
          }}
        </td>
      </tr>
      <tr>
        <td>Exchange Rate</td>
        <td class="font-weight-bold">
          1 {{ transactionInfo.coll_currency }} = {{ transactionInfo.rate }}
          {{ transactionInfo.pay_currency }}
        </td>
      </tr>
      <tr>
        <td>Payout Amount</td>
        <td class="font-weight-bold">
          <span class="font-weight-bold text--primary">
            {{
              transactionInfo.payout_amt ? transactionInfo.payout_amt : null
            }}</span
          >
        </td>
      </tr>
      <tr>
        <td>Bank Receipt</td>
        <td>
          <DocumentAttachment
            :url="transactionInfo.bank_receipt"
            label="Bank Receipt"
          />
        </td>
      </tr>
      <tr>
        <td>Customer Invoice</td>
        <td>
          <DocumentAttachment
            :url="transactionInfo.invoice_document"
            label="Customer Invoice"
          />
        </td>
      </tr>
      <tr>
        <td>Purpose of remittance</td>
        <td>
          <span class="font-weight-bold"
            >{{
              transactionInfo.purpose_of_remittance
                ? transactionInfo.purpose_of_remittance.value
                : null
            }}
          </span>
        </td>
      </tr>
      <tr>
        <td>Source of Funds</td>
        <td>
          <span class="font-weight-bold"
            >{{
              transactionInfo.source_of_funds
                ? transactionInfo.source_of_funds.value
                : null
            }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Deposit Type:
          <span class="font-weight-bold">{{
            transactionInfo.payment_mode ? transactionInfo.payment_mode : null
          }}</span>
        </td>
      </tr>
    </v-simple-table>
    <div class="text-center">
      <v-dialog persistent v-model="edittxnDialog" width="700px">
        <TxnInfoEdit
          @TxnDataUpdated="TxnDataUpdated"
          @closeDialog="closeDialog"
          :transactionInfo="transactionInfo"
          :user_type="user_type"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import DocumentAttachment from "@/components/common/DocumentAttachment.vue";
import TxnInfoEdit from "./EditTxnDetails/TxnInfoEdit.vue";

export default {
  data() {
    return {
      edittxnDialog: false,
    };
  },
  components: {
    DocumentAttachment,
    TxnInfoEdit,
  },
  props: {
    transactionInfo: {
      type: Object,
    },
    txn_status: {
      type: String,
    },
    user_type: {
      type: String,
    },
  },
  methods: {
    closeDialog() {
      this.edittxnDialog = false;
    },
    TxnDataUpdated() {
      this.$emit("TxnDataUpdated");
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
